import { combineReducers } from "redux";
import { loadingReducer } from "./loadingReducer";
import { uiReducer } from "./uiReducer";
import { whislistDataReducer } from "./whislistDataReducer";

export const rootReducer = combineReducers({
    
    loading:loadingReducer,
    wishlist:uiReducer,
    whislistDataReducer:whislistDataReducer,
})
